import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { bemFieldAccessGuard } from '../../shared/guards/bem-field-access.guard';
import { BemAdviceComponent } from './bem-advice.component';

export const bemAdviceRoutes: Routes = [
  {
    path: 'bem/:cropfieldId',
    component: BemAdviceComponent,
    canActivate: [CustomerGuard, bemFieldAccessGuard],
  },
];
